export function compareStringsCaseDiacriticInsensitive(valueA, valueB) {
  if (!valueA) return false;
  return !valueA.localeCompare(valueB, undefined, {
    sensitivity: "base",
  });
}

export function checkIfStringHasSpecialChar(_string) {
  //eslint-disable-next-line no-useless-escape
  const spChars = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

  return spChars.test(_string);
}
